<template>
    <div>
    </div>
</template>

<script>
    // https://github.com/Inndy/vue-clipboard2
   
    import { EventBus } from 'Js/eventBus';
    import VueClipboard from 'vue-clipboard2'
    Vue.use(VueClipboard)
        
    export default {
        props: [],
        name: 'clipboard',
        data() {
            return {}
        },

        components: {
            VueClipboard
        },
        
        methods: {
            doClipboard: function(action) {
                if (action.options.set) {
                    this.$copyText(action.options.set).then(function(e) {
                        console.log(e)
                    }, function(e) {
                    BF.errorThrow (10112, 'Error while copying text to clipboard.or details)' , {action, e})
    
                    })
                }
            }
        },

        mounted() {
            EventBus.$on('doClipboard', options => {
                this.doClipboard(options)
            });

        }
    }
     
</script>

<style>
</style>


